// Tier-2 <Badge> backed by AntD Badge (FORT-182). A count/dot/status indicator,
// typically wrapping an icon or avatar. Colour comes from the token-sourced AntD
// global theme — no raw values here.
import React from 'react';
import { Badge as AntBadge } from 'antd';
import type { CommonProps } from './types';

export type BadgeStatus = 'success' | 'processing' | 'default' | 'error' | 'warning';

export interface BadgeProps extends CommonProps {
  count?: number;
  dot?: boolean;
  showZero?: boolean;
  overflowCount?: number;
  status?: BadgeStatus;
  text?: React.ReactNode;
  children?: React.ReactNode;
}

export const Badge: React.FC<BadgeProps> = ({
  count,
  dot,
  showZero,
  overflowCount,
  status,
  text,
  children,
  className,
  style,
  'data-testid': dataTestId,
}) => (
  <AntBadge
    count={count}
    dot={dot}
    showZero={showZero}
    overflowCount={overflowCount}
    status={status}
    text={text}
    className={className}
    style={style}
    data-testid={dataTestId}
  >
    {children}
  </AntBadge>
);
